import { Database, Trash2 } from 'lucide-react';
import { cn } from '../../../lib/utils';

const DatasetSidebar = ({
  sources,
  previewDataset,
  setPreviewDataset,
  onConnect,
  onRemoveSource,
  onRebuildSource
}) => {
  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 overflow-y-auto px-2 space-y-0.5">
        {sources.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-12 text-center">
            <div className="p-3 bg-gray-50 dark:bg-gray-900/50 rounded-lg mb-3">
              <Database size={20} className="text-gray-300 dark:text-gray-700" />
            </div>
            <p className="text-[10px] font-medium text-gray-400 dark:text-gray-600 uppercase tracking-wider">
              No datasets
            </p>
          </div>
        ) : (
          sources.map(source => (
            <div
              key={source.id}
              onClick={() => setPreviewDataset(source)}
              className={cn(
                "flex items-center gap-2.5 px-2.5 py-2 rounded-lg transition-all cursor-pointer group relative",
                previewDataset?.id === source.id
                  ? "bg-emerald-50 dark:bg-emerald-900/20 text-emerald-700 dark:text-emerald-300"
                  : "hover:bg-gray-50 dark:hover:bg-gray-900/30 text-gray-700 dark:text-gray-300"
              )}
            >
              <div className={cn(
                "shrink-0 transition-colors",
                previewDataset?.id === source.id
                  ? "text-emerald-600 dark:text-emerald-400"
                  : "text-gray-400 group-hover:text-gray-600 dark:group-hover:text-gray-400"
              )}>
                <Database size={14} />
              </div>
              <div className="flex-1 min-w-0 pr-6">
                <div className="flex items-center gap-2">
                  <h4 className={cn(
                    "text-xs font-medium truncate",
                    previewDataset?.id === source.id
                      ? "text-emerald-700 dark:text-emerald-300"
                      : "text-gray-900 dark:text-gray-100"
                  )}>
                    {source.name}
                  </h4>
                  {source.status && source.status !== 'ready' && (
                    <span className={cn(
                      "text-[8px] font-medium uppercase tracking-wider px-1.5 py-0.5 rounded shrink-0",
                      source.status === 'failed'
                        ? "bg-red-100 text-red-600 dark:bg-red-900/30 dark:text-red-400"
                        : "bg-amber-100 text-amber-600 dark:bg-amber-900/30 dark:text-amber-400 animate-pulse"
                    )}>
                      {source.status === 'loading' ? 'Loading' :
                        source.status === 'generating' ? 'Generating' :
                          source.status}
                    </span>
                  )}
                </div>
                <p className="text-[9px] text-gray-500 dark:text-gray-500 mt-0.5 font-medium uppercase tracking-wide">
                  {source.type}
                </p>
              </div>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onRemoveSource(source.id);
                }}
                className={cn(
                  "absolute right-2 top-1/2 -translate-y-1/2 p-1 text-gray-300 hover:text-red-500 dark:text-gray-700 dark:hover:text-red-400 transition-all rounded opacity-0 group-hover:opacity-100",
                  previewDataset?.id === source.id && "opacity-100"
                )}
                title="Remove dataset"
              >
                <Trash2 size={11} />
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default DatasetSidebar;
